let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l9Og3")).then(() => parcelRequire('cJzXV'));